import React from 'react';

const PostsGridSkeleton = () => {
  return (
    <div className="w-full px-1 xs:px-2 sm:px-4 md:px-6 py-2 xs:py-4 sm:py-6 md:py-8">
      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }

        .skeleton-shimmer-white {
          animation: shimmer 2s infinite linear;
          background: linear-gradient(
            to right,
            #f0f0f0 0%,
            #ffffff 20%,
            #f0f0f0 40%,
            #f0f0f0 100%
          );
          background-size: 1000px 100%;
        }
      `}</style>

      <div className="grid grid-cols-3 gap-0.5 xs:gap-1 sm:gap-2 md:gap-3 lg:gap-4">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
          <div
            key={i}
            className="aspect-square relative bg-white rounded-sm xs:rounded md:rounded-lg shadow-sm overflow-hidden"
          >
            <div className="absolute inset-0 skeleton-shimmer-white" />

            <div className="relative p-1 xs:p-2 sm:p-3 md:p-4 h-full flex flex-col justify-between">
              <div className="flex items-center justify-between">
                <div
                  className="w-5 h-5 xs:w-5 xs:h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 rounded-full bg-gray-200"
                  style={{ opacity: 0.6 }}
                />
              </div>

              <div className="flex-1 flex items-center justify-center px-0.5 xs:px-1 sm:px-2">
                <div className="w-full space-y-1 xs:space-y-2">
                  <div
                    className="h-2 xs:h-3 sm:h-4 bg-gray-200 rounded mx-auto w-3/4"
                    style={{ opacity: 0.6 }}
                  />
                  <div
                    className="h-2 xs:h-3 sm:h-4 bg-gray-200 rounded mx-auto w-1/2"
                    style={{ opacity: 0.6 }}
                  />
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div
                  className="h-2 xs:h-2.5 sm:h-3 w-8 xs:w-10 sm:w-12 bg-gray-200 rounded"
                  style={{ opacity: 0.6 }}
                />
                <div
                  className="h-2 xs:h-2.5 sm:h-3 w-8 xs:w-10 sm:w-12 bg-gray-200 rounded"
                  style={{ opacity: 0.6 }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostsGridSkeleton;